import { usePathname, useSearchParams } from 'next/navigation'
import { useAction } from 'next-safe-action/hooks'

import { addToFavoriteList, type TFavoriteRoomEvent } from '@/entities/room'
import { AUTH } from '@/shared/api'
import { useAirbridgeContext, useServerErrorHandler } from '@/shared/config'
import { useCommonDialog } from '@/shared/lib'

type AddToFavoriteListActionProps = {
  onSuccess: () => void
}

export const useAddToFavoriteList = ({
  onSuccess,
}: AddToFavoriteListActionProps) => {
  const { handleServerError } = useServerErrorHandler()
  const { sendEvent } = useAirbridgeContext()

  const { openMoveToSignInDialog } = useCommonDialog()

  const pathname = usePathname()
  const searchParams = useSearchParams()

  const sendAirbridgeEvent = (airbridgeEvent: TFavoriteRoomEvent) => {
    const params = {
      action: airbridgeEvent.action,
      label: airbridgeEvent.label,
      value: airbridgeEvent.value,
      semanticAttributes: {
        products: [
          {
            productID: airbridgeEvent.productId,
            name: airbridgeEvent.productName,
            categoryName: airbridgeEvent.categoryName,
            price: airbridgeEvent.price,
            position: 1,
            currency: 'KRW',
          },
        ],
        currency: 'KRW',
      },
    }

    sendEvent({
      event: airbridgeEvent.eventName,
      params,
      onSuccess,
    })
  }

  const action = useAction(addToFavoriteList, {
    onSuccess: ({ data }) => {
      if (data?.airbridgeEvent) {
        sendAirbridgeEvent(data.airbridgeEvent)
      }
    },
    onError: ({ error }) => {
      if (error.serverError) {
        if (error.serverError.code === AUTH['002']) {
          const searchParamsString = searchParams?.toString()
          const currentPath = `${pathname}${searchParamsString ? `?${searchParamsString}` : ''}`

          openMoveToSignInDialog(currentPath)

          return
        }

        handleServerError(error.serverError)
      }
    },
  })

  return action
}
